require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-customer-acquisition.json") })
        }
      }, "path---authors-customer-acquisition");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-customer-acquisition!./.cache/json/authors-customer-acquisition.json
// module id = 1269
// module chunks = 231608221292675